import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, DialogContainer, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { default as ApiRequestService, default as apiRequestService } from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import SecureShow from '../component/SecureShow';
import TableRow from '../component/TableRow';
import styles from '../css/styles.css.js';
import CreateHelpMenu from './CreateHelpMenu';
import { AppSetting } from '../common/function';

let helpMenuList = {
  hm_name: '',
  hm_id: 0,
  hm_cat_id:0,
  hm_sub_cat_id:0
};

export default class HelpMenu extends Component {
  AppSetting = AppSetting()

  constructor(props) {
    super(props);
    this.state = {
      helpMenuArr: [],
      temp_helpMenu: helpMenuList,
      temp_id: 0,
      editVisible: false,
      visible: false,
      addMode: true,
      loading: true,
      currHmId:0,
      instructor_name:window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`),
      userprofilerole : parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10),
      hmCat_id: this.props.location.query.hm_cat_id,
      hmCat_name: this.props.location.query.hm_cat_name,
      hmSubCat_id: this.props.location.query.hm_sub_cat_id,
      hmSubCat_name: this.props.location.query.hm_sub_cat_name,
      instructorHmAccess : 0,
      editingAccess : false
    };

    this.deleteHelpMenu = this.deleteHelpMenu.bind(this);
    this.addHelpMenu = this.addHelpMenu.bind(this);
    this.getAllHelpMenu = this.getAllHelpMenu.bind(this);
    this.changeHelpMenuName = this.changeHelpMenuName.bind(this);
    this.updateHelpMenu = this.updateHelpMenu.bind(this);
    this.editHelpMenuHide = this.editHelpMenuHide.bind(this);
    
    this.isEnterPressed = this.isEnterPressed.bind(this);    
    
    // this.errorMessageHide= this.errorMessageHide.bind(this);
  }
  addBreadCrumbs = () => {
    console.debug('Topics AddBreadCrumbs');
    this.props.replaceBreadCrumb([
      {
        name: 'Help', 
        type: '', 
        onclickPath: 'helpMenuCat' 
      },
      {
        name: this.state.hmCat_name,
        type: '',
        onclickPath:
        'helpMenuSubCat?hm_cat_id=' +
        this.state.hmCat_id +
        '&hm_cat_name=' +
        this.state.hmCat_name
      },
      {
        name: this.state.hmSubCat_name,
        type: '',
        onclickPath:
        'HelpMenu?hm_cat_id=' +
        this.state.hmCat_id +
        '&hm_cat_name=' +
        this.state.hmCat_name +
        'HelpMenuSubCat?hm_sub_cat_id=' +
        this.state.hmSubCat_id +
        '&hm_sub_cat_name=' +
        this.state.hmSubCat_name
      }
    ]);
  };

  componentWillUpdate() {
    this.addBreadCrumbs();
  
  }

  componentWillMount() {
    console.debug('componentwillmount in HelpMenu',this.state.helpMenuArr)
       this.setState({ loading: true });
       if(this.state.userprofilerole === 2){
        this.setState({editingAccess : true})
      }else{
        this.getHelpMenuAccess();
      }
      this.getAllHelpMenu();
     
  }

  componentWillUnmount() {
    this.removeBreadCrumbs();
  }




  removeBreadCrumbs = () => {
      this.props.replaceBreadCrumb([
      ]);     
    

  };
  getHelpMenuAccess = () =>{
    const payload = {
      instructor_name: this.state.instructor_name
    };
    apiRequestService({
      method: 'post',
      url: '/getHmAccess',
      data: payload
    }).then(res => {
      if (res.data.data !== null && res.data.data !== undefined) {
        if( res.data.data.instructor_hm_access === 1){
          this.setState({
            instructorHmAccess : res.data.data.instructor_hm_access,
            editingAccess : true
          })
        }else{
          this.setState({
            instructorHmAccess : res.data.data.instructor_hm_access,
            editingAccess : false
          })
        }
      }
    })
  }

  getAllHelpMenu(){
    var hmCat_id = parseInt(this.state.hmCat_id, 10);
    var hmSubCat_id = parseInt(this.state.hmSubCat_id, 10);
    const payload = {
        hm_cat_id: hmCat_id,
        hm_sub_cat_id: hmSubCat_id
      };
    apiRequestService({
      method: 'post',
      url: '/getAllHelpMenu',
      data: payload
  }).then(res => {
      if (res.data.data !== null && res.data.data !== undefined) {
         
        this.setState({
          helpMenuArr : res.data.data.hm_names,
          loading: false 
        });                     
      }
  }).catch(err =>{
      console.error('ERROR : ', err);
      NotificationManager.error(err, 'ERROR', 3000);
      this.setState({ loading: false });
      this.hide();
    
  });
  }



  addHelpMenu() {
    var hmCat_id = parseInt(this.state.hmCat_id, 10);
    var hmSubCat_id = parseInt(this.state.hmSubCat_id, 10);
    
    console.debug('Add  :' + this.state.temp_helpMenu.hm_name);
    if (
      this.state.temp_helpMenu.hm_name === null ||
      this.state.temp_helpMenu.hm_name.trim() === ''
    ) {
      alert('Please enter a valid "Help name"');
      return;
    }
    this.setState({ loading: true });
    var tempHelpMenu = this.state.temp_helpMenu.hm_name.trim();
    const payload = {
      hm_name: tempHelpMenu,
      hm_cat_id: hmCat_id,
      hm_sub_cat_id:hmSubCat_id
      
    };
    ApiRequestService({
      method: 'post',
      url: '/addHelpMenu',
      data: payload
    }).then(res => {
      if (res.data.message !== null && res.data.message !== '') {
        console.error('ERROR : ', res.data.message);
        // Bug id #143 fixed
        this.setState({ loading: false });
        this.hide();
        NotificationManager.error(res.data.message, 'ERROR', 3000);
        return;
      }
      let temp_HelpMenu;
      if(this.state.helpMenuArr === null){
       temp_HelpMenu = [];
      }else{
         temp_HelpMenu =this.state.helpMenuArr ;
      }
      
      console.debug('response : ', res,this.state.helpMenuArr,temp_HelpMenu);
      if (res.data.data != null) {
        if (res.data.data.hm_name != null) { 
          temp_HelpMenu.push({
            hm_name: res.data.data.hm_name,
            hm_id: res.data.data.hm_id,
            hm_cat_id:res.data.data.hm_id
          });
          this.setState({
            helpMenuArr: temp_HelpMenu,
            loading: false
          });
        }
      }
      this.setState({
        loading: false
      });
      this.hide();
    });
  }

  editHelpMenu(id) {
    this.setState({
      //temp_helpMenu: this.state.helpMenuArr[id],
      currHmId: id,
      editVisible:true
      //addMode: false
    });
  }

  
  editHelpMenuHide(UpdatedpayloadFromHelpMenu) {
    this.state.helpMenuArr.forEach((helpMenuList, i) => {
      if (helpMenuList.hm_id === UpdatedpayloadFromHelpMenu.hm_id) {
        helpMenuList.hm_name = UpdatedpayloadFromHelpMenu.hm_name;
      }
    });
    this.setState({
        currHmId:0,
      editVisible:false,
      helpMenuArr: this.state.helpMenuArr
      //addMode: false
    });
  }

  updateHelpMenu() {
    this.setState({ loading: true });
    console.debug('Editing  :' + this.state.temp_helpMenu.hm_id);
    var hmCat_id = parseInt(this.state.hmCat_id, 10);
    var hmSubCat_id = parseInt(this.state.hmSubCat_id, 10);
    const payload = {
        hm_id: this.state.temp_helpMenu.hm_id,
        hm_name: this.state.temp_helpMenu.hm_name,
        hm_cat_id: hmCat_id,
        hm_sub_cat_id:hmSubCat_id
      };
  //  const payload = this.state.temp_helpMenu;

    ApiRequestService({
      method: 'post',
      url: '/updateHelpMenu',
      data: payload
    }).then(res => {
      if(res.data.message !== null && res.data.message !== ""){
        if(res.data.message.toLowerCase().indexOf("duplicate")>=0){
            NotificationManager.error("Duplicate entry.This  Already Exists", 'Error Message', 5000);
            this.setState({loading: false
            });
        }else{
            NotificationManager.error(res.data.message, 'Error Message', 5000);
            this.setState({loading: false
            });
        }
    } else {
        NotificationManager.success('Subject Added', 'Success');
    
        console.debug(res);
        console.debug('Update State: ', this.state.helpMenuArr);
        this.setState({
          helpMenuArr: this.state.helpMenuArr,
          temp_helpMenu: helpMenuList,
          loading: false
        });
        
    }
    });
    this.hide();
    this.getAllHelpMenu();
  }
  deleteHelpMenu(id,index) {
    var hmCat_id = parseInt(this.state.hmCat_id, 10);
    var hmSubCat_id = parseInt(this.state.hmSubCat_id, 10);
    
    this.setState({ loading: true });
    console.debug(
      'Deleting helpMenuList i:' + id
    );
    const payload = {
      hm_id:id,
      hm_cat_id: hmCat_id,
      hm_sub_cat_id:hmSubCat_id      
    };
    ApiRequestService({
      method: 'post',
      url: '/deleteHelpMenu',
      data: payload
    })
      .then(res => {
        console.debug(res);
        //window.localtion.reload();
        console.debug('before Spliced Array', this.state.helpMenuArr);
        this.state.helpMenuArr.splice(index, 1);
        console.debug('Spliced Array', this.state.helpMenuArr);
        this.setState({
          helpMenuArr: this.state.helpMenuArr,
          loading: false
        });
      })
      .catch(error => {
        //bug-tracker#162

        console.error('Error When Deleting ', error);
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            'Unauthorized',
            'You are not authorized to delete helpMenuList',
            5000
          );
        }
        this.setState({
          loading: false
        });
      });
  }
  changeHelpMenuName(e) {
    let curHelpMenuName = this.state.temp_helpMenu;
    curHelpMenuName.hm_name = e;
    this.setState({
      temp_helpMenu: curHelpMenuName
    });
  }

  show = isAddDialogEnable => {
    //

    if (isAddDialogEnable) {
      this.setState({
        temp_helpMenu: {
          hm_name: '',
          hm_id: ''
        }
      });
    }
    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({
      visible: false,
      addMode: true
    });
  };
  
  delete = (id,index) => {

    confirmAlert({
      title: 'Are you sure want to delete?',
      message: 'Press Confirm to submit',
      confirmLabel: 'Cancel',
      cancelLabel: 'Confirm',

      onCancel: () => this.deleteHelpMenu(id,index)
      //   onCancel: () => ,
    });
  };

  isEnterPressed(event){
    var code = event.keyCode || event.which;
    if(code === 13) { //13 is the enter keycode
      this.addHelpMenu()
    } 
  }

  render() {
      

    let button = null;
  //  if (this.state.addMode) {
      button = (
        <button style={styles.addButton} onClick={this.addHelpMenu}>
          Add 
        </button>
      );
   /* }else {
      button = (
        <button style={styles.addButton} onClick={this.updateHelpMenu}>
          Update 
        </button>
      );*/
    //}
    var cancelButton = (
      <button style={styles.cancelButton} onClick={this.hide}>
        Cancel
      </button>
    );

    const actions = [];
    actions.push(button);
    actions.push(cancelButton);
    var tableRows = (this.state.helpMenuArr != null
      ? this.state.helpMenuArr.map((helpMenuList, i) => (
        
        
          <TableRow
            key={i}
            data={helpMenuList}
            id={helpMenuList.hm_id}
            name={helpMenuList.hm_name}
            title={'Help'}
            type={''}
            /*url={
              'HelpMenu?hm_id=' +
              helpMenuList.hm_id +
              '&hm_name=' +
              helpMenuList.hm_name
            }*/
            onEditClick={() => this.editHelpMenu(helpMenuList.hm_id)}
            pushId={'helpMenuList'}
            onDeleteClick={() => this.delete(helpMenuList.hm_id,i)}
            instructorSubject={this.state.editingAccess ?  true : false}
          />
        ))
      : '')

    return (

      (this.state.loading)?
         <LoadingSpinner loading={this.state.loading} />
      :
      <SecureShow targetRole={1}>

        <div style={{ width: '90%' }}>
          <div style={styles.subjectTitle}>
            Help Explanation
            <div style={this.state.editingAccess ? {float: "right"}:{display:"none"}}>
              <Button className="archive-button" primary raised 
                onClick={() => this.show(true)}>
                  Add a New Help Explanation
              </Button>
            </div>
          </div>
          <div>
            {
              <DialogContainer
                id="simple-action-dialog"
                visible={this.state.visible}
                onHide={this.hide}
                actions={actions}
                //title="New Subject"
                width="500px"
              >
              <p style={{fontSize:"medium"}}><b><label for="hmId">Help Explanation</label></b></p>
{/*                 <input
                  id="hmId"
                  type="text"
                  name="hm_name"
                  //defaultValue={this.state.temp_helpMenu.hm_name || ''}
                  onChange={this.changeHelpMenuName}
                  style={subjectStyles.dialogText}
                  onKeyPress={this.isEnterPressed.bind(this)}              
                /> */}
                <TextField 
                  id="hmId"
                  name="hm_name"
                  onChange={this.changeHelpMenuName}
                  onKeyPress={this.isEnterPressed.bind(this)}              
                />
              </DialogContainer>
            }
          </div>
          <table style={styles.subjectTable}>
            <thead style={styles.thead}>
              <tr>
                <th>ID</th>
                <th>Help Explanation</th>
                {this.state.editingAccess ? (<th>Actions</th>):("")}
              </tr>
            </thead>

            <tbody>
              {tableRows}
            </tbody>
          </table>
        </div>
        <DialogContainer
          id="navigation-drawer-demo"
          aria-label="Navigation Drawer Demo"
          visible={this.state.editVisible}
          fullPage
          focusOnMount={false}
          
        >
          <div>
            {' '}
            <Button icon onClick={this.editHelpMenuHide}>
              close
            </Button>
          </div>
          <div style={{ overflow: 'hidden' }}>
            <CreateHelpMenu
              selectedHmCatId={this.state.hmCat_id}
              selectedHmSubCatId={this.state.hmSubCat_id}
              selectedHmId={this.state.currHmId}
              close={this.editHelpMenuHide}
            />
          </div>
          <br/>

          <div />
        </DialogContainer>
        
      </SecureShow>
    );
  }
}
